import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("app", ["getPageDirty", "checkWholePageDirty"]),
    dirtyId() {
      //to be overwritten
      return "";
    },
  },
  methods: {
    ...mapActions("app", ["addPageDirty", "removePageDirty", "clearPageDirty"]),
    //todo: add config/options
    setDirty(id) {
      this.addPageDirty(id);
    },
    isComponentDirty() {
      return this.getPageDirty(this.dirtyId);
    },
    isDirty(id) {
      return this.getPageDirty(id);
    },
    removeDirty(id) {
      this.removePageDirty(id);
    },
    removeComponentDirty() {
      this.removePageDirty(this.dirtyId);
    },
    clearDirty() {
      this.clearPageDirty();
    },
    promptPageDirty() {
      return new Promise((resolve) => {
        if (!this.checkWholePageDirty) {
          return resolve(true);
        }
        if (!confirm(this.$i18n.t("dirty_confirmation_prompt"))) {
          return resolve(false);
        } else {
          this.clearDirty();
          return resolve(true);
        }
      });
    },
    promptComponentDirty() {
      return new Promise((resolve) => {
        if (!this.isDirty(this.dirtyId)) {
          return resolve(true);
        }
        if (!confirm(this.$i18n.t("dirty_confirmation_prompt"))) {
          return resolve(false);
        } else {
          this.removeDirty(this.dirtyId);
          return resolve(true);
        }
      });
    },
  },
};
